import { render, staticRenderFns } from "./ShockModal.vue?vue&type=template&id=837e36ea&scoped=true&"
import script from "./ShockModal.vue?vue&type=script&lang=js&"
export * from "./ShockModal.vue?vue&type=script&lang=js&"
import style0 from "./ShockModal.vue?vue&type=style&index=0&id=837e36ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837e36ea",
  null
  
)

export default component.exports